<script setup>
import Vue, {ref, inject} from "vue";
import {download} from "@/helpers/file";
import needsService from "@/services/needs.service";

const need = inject('need');
const loading = ref(false);

async function getReport() {
    loading.value = true;

    try {
        const {data} = await needsService.getReport(need.value.id);

        if (data.size < 100) {
            Vue.notify({
                group: 'app',
                type: 'error',
                duration: 5000,
                text: "Error occurred. Please try again later."
            })
        } else {
            let currentDate = new Date();
            download(data, `report-${currentDate.toLocaleDateString()}-${currentDate.toLocaleTimeString()}.pdf`);
        }
    } finally {
        loading.value = false;
    }
}
</script>

<template>
    <div class="card-headline">
        <header class="card-headline__header">Summary Report</header>

        <div class="card-headline__inner">
            <img :src="require('@/images/modal-previews/img1.png')">
        </div>

        <footer class="card-headline__footer">
            <a v-if="loading" class="link d-flex justify-content-end">
                Generating Report...
            </a>

            <a v-else class="link link--view d-flex justify-content-end" @click="getReport">
                View
            </a>
        </footer>
    </div>
</template>

<style scoped>

</style>
